import React, {useContext, useState} from "react";
import styles from "./workspaceItems/WorkspaceItems.module.scss";
import Item from "./workspaceItems/Item";
import {Scrollbars} from "react-custom-scrollbars";
import appContext from "../../../../context/appContext";
import WorkspaceSettings from "../WorkspaceSettings";

const WorkspaceItems = ({ selectedWorkspaceId, handleShowCreateWorkspaceModal, handleSelectWorkspaceItem, handleEditWorkspace, handleRetrySaveData, onFetchMoreItems }) => {
    const [showWorkspaceSettingsModal, setShowWorkspaceSettingsModal] = useState(false)

    const context = useContext(appContext);
    const workspaceData = context.handleWorkspace();
    const ref = React.useRef()

    const role = localStorage.getItem("role")

    const handleScroll = (e) => {
      if (e.target.clientHeight + e.target.scrollTop >= e.target.scrollHeight) {
        onFetchMoreItems()
      }
    }

    React.useEffect(() => {
      if(ref.current.clientHeight + ref.current.scrollTop >= ref.current.scrollHeight) {
        onFetchMoreItems()
      }
    }, [])

    return (
        <div className={`${styles.WorkspaceItems}`}>
            <div className={styles.header}>
                <span>Workspaces</span>
              {
                (role === "admin" || role === "analyzer") &&
                  <svg
                    onClick={handleShowCreateWorkspaceModal}
                    className={`${styles.plusIcon} ${(context.handleLostWorkspaceDataConnector() || context.handleSaveWorkspaceStatus() === 'error' || context.handleSaveWorkspaceStatus() === 'fetching') && styles.disabled}`}
                    width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9.99997 6.93945V13.0447" stroke="#8A0FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.0556 9.99209H6.94446" stroke="#8A0FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M13.9047 1.66669H6.0952C3.37298 1.66669 1.66663 3.59342 1.66663 6.32098V13.6791C1.66663 16.4066 3.36504 18.3334 6.0952 18.3334H13.9047C16.6349 18.3334 18.3333 16.4066 18.3333 13.6791V6.32098C18.3333 3.59342 16.6349 1.66669 13.9047 1.66669Z" stroke="#8A0FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
              }
            </div>
            <div ref={ref} className={styles.itemsList}>
                <Scrollbars
                    onScroll={handleScroll}
                    renderView={({ style, ...props }) =>
                        <div {...props} style={{ ...style, width: "100%", height: "calc(100vh - 150px)", overflowX: 'hidden', paddingLeft: 16, paddingRight: 0 }}/>}
                    // renderTrackVertical={({ style, ...props }) =>
                    //     <div {...props} style={{ ...style, backgroundColor: '#C2C7ED', width: 1, borderRadius: 4, height: "100%", left: 0, paddingBottom: 1 }}/>
                    // }
                    renderThumbVertical={({ style, ...props }) =>
                        <div {...props} style={{ ...style, backgroundColor: '#70789E', width: 4, borderRadius: 4, cursor: "pointer", right: 232}}/>
                    }
                >
                    { workspaceData.length > 0 && workspaceData.map(item => (
                        <Item
                            isActive={selectedWorkspaceId === item.id}
                            handleSelectWorkspaceItem={handleSelectWorkspaceItem}
                            item={item}
                            description={"Description Goes Here"}
                            handleEditWorkspace={handleEditWorkspace}
                            handleRetrySaveData={handleRetrySaveData}
                            onTriggerShowWorkspaceSettingsModal={() => setShowWorkspaceSettingsModal(!showWorkspaceSettingsModal)}
                        />
                    )) }
                </Scrollbars>
            </div>
            <WorkspaceSettings
              showModal={showWorkspaceSettingsModal}
              onTriggerShowWorkspaceSettingsModal={() => setShowWorkspaceSettingsModal(!showWorkspaceSettingsModal)}
            />
        </div>
    )
}

export default WorkspaceItems;